// Trustline Validation Engine Contract Addresses
// Easily editable array structure for future updates

export interface ContractAddress {
  chainId: number;
  chainName: string;
  version: string;
  address: string;
  isTestnet: boolean;
}

export const TRUSTLINE_VALIDATION_ENGINE_ADDRESSES: ContractAddress[] = [
  // Ethereum Mainnet
  {
    chainId: 1,
    chainName: 'Ethereum',
    version: 'Version 1',
    address: '0x0000000000000000000000000000000000000000', // Placeholder
    isTestnet: false,
  },
  
  // Sepolia Testnet
  {
    chainId: 11155111,
    chainName: 'Sepolia',
    version: 'Version 1',
    address: '0x3323840a5400adf89c48Dfe608Bb28fD71212da5', // Placeholder
    isTestnet: true,
  },
  
  // Base Mainnet
  {
    chainId: 8453,
    chainName: 'Base',
    version: 'Version 1',
    address: '0x0000000000000000000000000000000000000000', // Placeholder
    isTestnet: false,
  },
  
  // Base Sepolia Testnet
  {
    chainId: 84532,
    chainName: 'Base Sepolia',
    version: 'Version 1',
    address: '0x3323840a5400adf89c48Dfe608Bb28fD71212da5', // Placeholder
    isTestnet: true,
  },
  
  // HyperEVM Testnet
  {
    chainId: 998,
    chainName: 'HyperEVM Testnet',
    version: 'Version 1',
    address: '0x3323840a5400adf89c48Dfe608Bb28fD71212da5', // Placeholder
    isTestnet: true,
  },
  
  // HyperEVM Mainnet
  {
    chainId: 999,
    chainName: 'HyperEVM',
    version: 'Version 1',
    address: '0x3323840a5400adf89c48Dfe608Bb28fD71212da5', // Placeholder
    isTestnet: false,
  },
  
  // XRPL EVM Sidechain Testnet
  {
    chainId: 1449000,
    chainName: 'XRPL EVM Sidechain Testnet',
    version: 'Version 1',
    address: '0x3323840a5400adf89c48Dfe608Bb28fD71212da5', // Placeholder
    isTestnet: true,
  },
  
  // XRPL EVM Sidechain Mainnet
  {
    chainId: 1440000,
    chainName: 'XRPL EVM Sidechain',
    version: 'Version 1',
    address: '0x3323840a5400adf89c48Dfe608Bb28fD71212da5', // Placeholder
    isTestnet: false,
  },
  
  // Polygon Mainnet
  {
    chainId: 137,
    chainName: 'Polygon',
    version: 'Version 1',
    address: '0x0000000000000000000000000000000000000000', // Placeholder
    isTestnet: false,
  },
  
  // Polygon Amoy Testnet
  {
    chainId: 80002,
    chainName: 'Polygon Amoy',
    version: 'Version 1',
    address: '0x0000000000000000000000000000000000000000', // Placeholder
    isTestnet: true,
  },
];

// Helper function to get addresses by chain
export const getAddressesByChain = (chainName: string): ContractAddress[] => {
  return TRUSTLINE_VALIDATION_ENGINE_ADDRESSES.filter(
    addr => addr.chainName === chainName
  );
};

// Helper function to get mainnet addresses
export const getMainnetAddresses = (): ContractAddress[] => {
  return TRUSTLINE_VALIDATION_ENGINE_ADDRESSES.filter(addr => !addr.isTestnet);
};

// Helper function to get testnet addresses
export const getTestnetAddresses = (): ContractAddress[] => {
  return TRUSTLINE_VALIDATION_ENGINE_ADDRESSES.filter(addr => addr.isTestnet);
};

